import { Translations } from './en';

export const no: Translations = {
    welcome: 'Velkommen',
    welcomeMessage: 'Logg inn på plandag for å se din plan.',
    login: 'Logg inn',
    register: 'Registrer',
    forgotPassword: 'Glemt passord',
    resetPassword: 'Nullstill passord',
    email: 'E-post',
    password: 'Passord',
    confirmPassword: 'Bekreft passord',
    rememberMe: 'Husk meg',
    continue: 'Fortsett',
    selectOrganization: 'Velg organisasjon',
    organizationEmail: 'E-posten <span class="font-semibold text-[#00165A] bg-slate-100 px-1.5 py-0.5 rounded">{{email}}</span> er tilknyttet flere organisasjoner.',
    organizationEmailMessage: 'Vennligst velg arbeidsområdet du vil ha tilgang til.',
    organization: 'Organisasjon',
    chooseOrganization: 'Velg en organisasjon',
    backToLogin: 'Tilbake til login',
    theEmail: 'E-posten',
    isAssociatedWithMultipleOrganizations: 'er tilknyttet flere organisasjoner.',
    theSimplestWayToManage: 'Den enkleste måten å administrere',
    yourWorkforce: 'din arbeidsstyrke',
    loginRightPanelMessage: 'Utnytt ditt team med et håndteringsverktøy bygget for hastighet, enkelhet og kontroll. Fra budsjettsporing til arbeidsflytautomatisering, alt fungerer sammen slik at du kan fokusere på vekst, ikke administrasjon.',
    personalDetails: 'Personlige detaljer',
    businessDetails: 'Bedriftsdetaljer',
    createYourAccount: 'Opprett konto',
    name: 'Navn',
    willBeUsedAsUsernameForLogin: '(vil bli brukt som brukernavn for login)',
    enterYourName: 'Skriv inn navn',
    enterYourEmail: 'Skriv inn e-post',
    select: '--Velg--',
    phoneNumber: 'Telefonnummer',
    enterYourMobileNumber: 'Skriv inn mobilnummer',
    country: 'Land',
    atLeastOneLowercase: 'Minst én lowercase',
    atLeastOneUppercase: 'Minst én uppercase',
    atLeastOneNumeric: 'Minst én numerisk',
    minimum8Characters: 'Minimum 8 tegn',
    agreeAndContinue: 'Godta og fortsett',
    personalDetailsMessage: 'Denne språket vil være standard for systemnotifikasjoner og nye brukere. Du kan alltid justere det i brukerinnstillinger senere.',
    agreeAndContinueMessage: 'Ved å klikke godta og fortsett, bekrefter du at du har lest og godtatt vår Databehandlingsavtale, Personvernspolicy, Forsøksvilkår og Generelle vilkår og samtykker til å motta salgskommunikasjon via telefon, e-post eller Wiser-appen under din 30-dagers forsøk. Du kan avslutte til enhver tid.',
    tellUsAboutYourBusiness: 'Fortell oss om din bedrift',
    withABusinessDetails: 'Med noen bedriftsdetaljer, vil vi forme Wiser for din bedrift med ditt domene',
    businessName: 'Bedriftsnavn',
    enterYourBusinessName: 'Skriv inn bedriftsnavn',
    businessLocation: 'Bedriftssted',
    businessType: 'Bedriftstype',
    language: 'Språk',
    timezone: 'Tidssone',
    howManyEmployeesDoYouHave: 'Hvor mange ansatte har du?',
    previous: 'Forrige',
    createAccount: 'Opprett konto',
    startYour30DaysTrial: 'Start din 30 dagers forsøk',
    noCreditCardRequired: 'Ingen kredittkort påkrevd!',
    exploreWiserFeaturesAtNoCost: 'Utforsk Wiser-funksjoner uten kostnad!',
    forgotYourPassword: 'Glemt passord?',
    enterYourEmailAddressAndWeWillSendYou: 'Skriv inn e-postadressen din og vi vil sende deg',
    instructionsToResetYourPassword: 'instrukser for å nullstille passordet ditt.',
    youHaveReachedTheEmailRequestLimit: 'Du har nådd e-postbegrensningen. Vennligst sjekk innboksen din eller prøv igjen om 15 minutter.',
    checkYourEmail: 'Sjekk e-posten',
    pleaseCheckTheEmailAddress: 'Vennligst sjekk e-postadressen',
    forInstructionsToResetYourPassword: 'for instrukser for å nullstille passordet ditt.',
    aNewEmailHasBeenSentToYourInbox: 'En ny e-post har blitt sendt til innboksen din.',
    resendEmail: 'Send e-post på nytt',
    edit: 'Rediger',
    thisFieldIsRequired: 'Dette feltet er påkrevd',
    invalidEmailAddress: 'Ugyldig e-postadresse',
    pleaseEnterAValidEmailAddress: 'Vennligst skriv inn en gyldig e-postadresse',
    invalidPassword: 'Ugyldig passord',
    minimumLengthIs: 'Minimum lengde er {{length}}',
    maximumLengthIs: 'Maksimum lengde er {{length}}',
    passwordsDoNotMatch: 'Passordene matcher ikke',
    invalidField: 'Ugyldig felt',
}